import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

export const Pencil01 = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="25" height="24" viewBox="0 0 25 24">
            <g id="pencil-01">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.494 4.05742L6.67857 15.2506L9.72085 17.8583L20.693 7.25641C21.5709 6.3726 21.5691 4.94447 20.6875 4.06292C19.806 3.18139 18.3779 3.17955 17.494 4.05742ZM8.07255 19.0796L4.64152 20.1089L5.58895 16.9508L8.07255 19.0796ZM16.0743 2.64871C17.7387 0.984287 20.4373 0.984282 22.1017 2.64871C23.7661 4.31313 23.7661 7.0117 22.1017 8.67612L22.0895 8.68815L9.84492 20.5195C9.73008 20.6305 9.59035 20.7123 9.4374 20.7582L3.4374 22.5582C3.08503 22.6639 2.70307 22.5676 2.44294 22.3075C2.18281 22.0474 2.08651 21.6654 2.19222 21.313L3.99222 15.313C4.03811 15.1601 4.11995 15.0204 4.23091 14.9055L16.0623 2.66095L16.0743 2.64871Z"
                    className="fill-current"
                />
            </g>
        </SvgIcon>
    );
};
